import { Media } from '../types';
import { getFileDetails } from './getFileDetails';

// strip out filePath and fileUrn because backend only likes fileRef when we are saving back to the backend
export const formatMediaItem = (mediaItem: Media): Media | undefined => {
  return mediaItem?.file
    ? {
        file: { fileRef: mediaItem.file.fileUrn || mediaItem.file.fileRef },
        addedAt: mediaItem.addedAt,
        path: mediaItem.file.filePath || mediaItem.path,
        nameAndType: mediaItem.file.filePath ? getFileDetails(mediaItem.file.filePath) : mediaItem.nameAndType,
      }
    : undefined;
};

export const formatMediaItems = (mediaItems?: Array<Media>): Array<Media> | undefined => {
  if (!mediaItems) return undefined;
  const formatted: Media[] = mediaItems
    .map((mediaItem: Media) => formatMediaItem(mediaItem))
    .filter((item): item is Media => Boolean(item));

  if (formatted.length > 0) {
    return formatted;
  }
  /**
   * If no files are found, return an empty array(if we returned undefined JSON.stringify would strip the field) meaning
   * when the last file is removed the backend would not receive the field change
   * https://askproducts.atlassian.net/browse/NS-1706
   */
  return [];
};
